import React from 'react';
import { connect } from 'react-redux';

import classes from './HotelAllAmenities.scss';

import * as hotelActions from '../../../store/actions/index';


const hotelAllAmenities = (props) => {
    console.log("REndered");
    const amenitiesCategory = [];
    const selectedAmenitiesList = [];
    for(let i = 0; i < props.groupedAmenities.length; i++) {
        if(props.groupedAmenities[i][0].category === props.selectedAmenity) {
            for(let j = 0; j < props.groupedAmenities[i].length; j++) {
                selectedAmenitiesList.push(<li key={j} className={`${classes.Amenity} pb-2 u-fontSize13 u-textColorNormal`}>- {props.groupedAmenities[i][j].name}</li>);
            }
        }
        amenitiesCategory.push(
            <li onClick={() => props.onSetSelectedAmenity(props.groupedAmenities[i][0].category)} key={i} className={`${props.groupedAmenities[i][0].category === props.selectedAmenity ? classes.SelectedAmenity : null} ${classes.AmenitiesCategory} u-textUppercase u-fontSize13 u-fontWeightMedium`}>{props.groupedAmenities[i][0].category}</li>
        );
    }

    return (
        <div className="u-flex">
            <div className={`${classes.BoxOne} u-textColorNormal u-backgroundColorLightGrey pl-6 pt-10 pb-10`}>
                <ul>
                    {amenitiesCategory}
                </ul>
            </div>
            <div className={`${classes.BoxTwo} u-backgroundWhite pl-14 pr-14`}>
                <ul className="u-flex f-wrap pt-10">
                    {selectedAmenitiesList}
                </ul>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        groupedAmenities: state.hotels.groupedAmenities,
        selectedAmenity: state.hotels.selectedAmenity
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetSelectedAmenity: (selectedAmenity) => dispatch(hotelActions.setSelectedAmenity(selectedAmenity))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(hotelAllAmenities);


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelAllAmenities/HotelAllAmenities.js